import NoDataSvg from '../../assets/icons/no_data.svg';
const EmptyData = () => {
  return (
    <div className="flex items-center justify-center h-64 flex-col w-fit">

         <img src={NoDataSvg} alt="No Data" className="w-32 h-32" />
      <p className="text-gray-500 text-lg">Oops! Nothing here yet</p>

    </div>
  );
};

export default EmptyData;